import Candidate from './Candidate';

export default Candidate;
